export const getDataForExercise = ({
	exerciseReducer: { list_ids, selected_words, exercise_type_code, id },
}) => ({
	id,
	list_ids,
	selected_words,
	exercise_type_code,
});

export const getHintType = ({ exerciseReducer: { hint_type, id } }) => ({
	id,
	hint_type,
});

export const getPausedExercise = ({ listDetailsReducer: { paused_exercise } }) => paused_exercise;
